import { render, staticRenderFns } from "./StudentAddCredit.vue?vue&type=template&id=d5d10282&"
import script from "./StudentAddCredit.vue?vue&type=script&lang=js&"
export * from "./StudentAddCredit.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddCredit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports